"use strict";

const {
  ValidationError
} = require('yup');

const getPropsToCopy = error => {
  const {
    name,
    message,
    stack,
    constructor,
    originalError,
    toJSON,
    ...propsToCopy
  } = error;
  return propsToCopy;
};

class ConfigurationError extends Error {
  constructor() {
    super(...arguments);
    this.name = this.constructor.name;
  }

}

class Web3ProviderError extends Error {
  constructor(message, originalError) {
    super(message);
    this.name = this.constructor.name;
    this.originalError = originalError;

    if (originalError && typeof originalError === 'object') {
      Object.assign(this, getPropsToCopy(originalError));
    }
  }

}

class Web3ProviderCallError extends Web3ProviderError {
  constructor() {
    super(...arguments);
    this.name = this.constructor.name;
  }

}

class Web3ProviderSendError extends Web3ProviderError {
  constructor() {
    super(...arguments);
    this.name = this.constructor.name;
  }

}

class Web3ProviderSignMessageError extends Web3ProviderError {
  constructor() {
    super(...arguments);
    this.name = this.constructor.name;
  }

}

class ObjectNotFoundError extends Error {
  constructor(objName, objId, chainId) {
    super("No ".concat(objName, " found for id ").concat(objId, " on chain ").concat(chainId));
    this.name = this.constructor.name;
    this.objName = objName;
    this.chainId = chainId;
    this.objectId = objId;
  }

}

class BridgeError extends Error {
  constructor(originalError, sendTxHash) {
    super("Failed to get bridged chain confirmation for transaction ".concat(sendTxHash));
    this.name = this.constructor.name;
    this.sendTxHash = sendTxHash;
    this.originalError = originalError;

    if (originalError && typeof originalError === 'object') {
      Object.assign(this, getPropsToCopy(originalError));
    }
  }

}

module.exports = {
  ConfigurationError,
  ObjectNotFoundError,
  ValidationError,
  Web3ProviderError,
  Web3ProviderCallError,
  Web3ProviderSendError,
  Web3ProviderSignMessageError,
  BridgeError
};